import { useAuthStore } from '@/mini/stores/auth'
import { apiUrl } from '@/config/api'

async function request(path, options = {}) {
  const auth = useAuthStore()
  const response = await auth.authFetch(apiUrl(path), {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  })
  if (!response.ok) {
    const body = await response.json().catch(() => ({}))
    throw new Error(body.error || body.detail || `Request failed: ${response.status}`)
  }
  if (response.status === 204) return null
  return response.json()
}

export function listCards(params = {}) {
  const query = new URLSearchParams(params).toString()
  return request(`/api/v1/cards/${query ? `?${query}` : ''}`)
}

export function getCard(id) {
  return request(`/api/v1/cards/${id}/`)
}

export function createCard(payload) {
  return request('/api/v1/cards/', { method: 'POST', body: JSON.stringify(payload) })
}

export function updateCollection(cardId, payload) {
  return request(`/api/v1/cards/${cardId}/collection/`, { method: 'PATCH', body: JSON.stringify(payload) })
}

export function listGroups() {
  return request('/api/v1/groups/')
}

export function addToGroup(cardId, payload) {
  return request(`/api/v1/cards/${cardId}/groups/`, { method: 'POST', body: JSON.stringify(payload) })
}

export function updateGroupEntry(cardId, entryId, payload) {
  return request(`/api/v1/cards/${cardId}/groups/${entryId}/`, { method: 'PATCH', body: JSON.stringify(payload) })
}

export function deleteGroupEntry(cardId, entryId) {
  return request(`/api/v1/cards/${cardId}/groups/${entryId}/`, { method: 'DELETE' })
}

export function getStats() {
  return request('/api/v1/cards/stats/')
}

export function getMe() {
  return request('/api/v1/me/')
}
